// Calls admin-only backend endpoints (routes/stripe.js requireAdminKey) with
// `Authorization: Admin <key>` — a header the API's CORS setup already allows.
// The key is never bundled: on the first 401 we ask once and keep it in this
// browser's localStorage; a rejected key is forgotten so the next call asks again.

const STORAGE_KEY = 'dstribute-admin-key';

function storedKey(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return ''; // private mode / storage disabled
  }
}

function send(input: string, init: RequestInit, key: string): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Admin ${key}`);
  return fetch(input, { ...init, headers });
}

export async function adminFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const res = await send(input, init, storedKey());
  if (res.status !== 401) return res;

  const entered = window.prompt('Enter admin key:')?.trim();
  if (!entered) return res;
  const retry = await send(input, init, entered);
  try {
    if (retry.status === 401) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, entered);
  } catch {
    /* private mode / storage disabled — just don't persist */
  }
  return retry;
}
